var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 15.1406C28.6717 15.4462 27.9275 15.6476 27.166 15.7383C27.9663 15.2697 28.5681 14.5252 28.8586 13.6445C28.102 14.087 27.2756 14.3974 26.4148 14.5625C26.0524 14.1826 25.6165 13.8804 25.1336 13.6743C24.6507 13.4681 24.1309 13.3623 23.6059 13.3633C21.4801 13.3633 19.7598 15.0586 19.7598 17.1484C19.7583 17.4391 19.7916 17.729 19.859 18.0117C18.3346 17.9403 16.842 17.5514 15.4766 16.87C14.1111 16.1887 12.9029 15.2298 11.9293 14.0547C11.5877 14.6305 11.4071 15.2875 11.4062 15.957C11.4062 17.2695 12.091 18.4297 13.125 19.1094C12.5124 19.0948 11.9123 18.9327 11.3758 18.6367V18.6836C11.3758 20.5195 12.7039 22.0469 14.4617 22.3945C14.1312 22.4827 13.7905 22.5273 13.4484 22.5274C13.2057 22.5278 12.9635 22.5042 12.7254 22.457C13.2141 23.9609 14.6363 25.0547 16.3211 25.0859C14.9521 26.141 13.2713 26.7112 11.543 26.707C11.2362 26.7066 10.9297 26.6883 10.625 26.6524C12.3833 27.7751 14.4271 28.369 16.5133 28.3633C23.5977 28.3633 27.468 22.5938 27.468 17.5899C27.468 17.4258 27.4637 17.2617 27.4559 17.1016C28.2071 16.5672 28.857 15.9032 29.375 15.1406Z",
    fill: "#929CB0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.36328,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E7EBF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7643a066bbfaa20b2a41434cd25b567a.svg";
export { ForwardRef as ReactComponent };